var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.getPromoBlocks),function(banner,index){return _c(banner.section.component,{key:index,tag:"component",attrs:{"section":banner.section,"docked":true},on:{"favorite":() => _vm.onFavorite(banner.section),"delete":() => _vm.onDelete(banner)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }